import React, { useState } from 'react';
import { getFile, getStatus } from '../../client';
import { useNavigate, useParams } from 'react-router-dom';
import { ImageViewer } from '../../elements/imageViewer';
import {message, Progress, Typography, Collapse} from 'antd';
import type { CollapseProps } from 'antd';

import './style.css'

interface IResoltCollapse{
    shortAnalytics: React.ReactNode;
    numberBigAnalytics: number;
    stringBigAnalytics: string;
}

const ResultCollapse: React.FC<IResoltCollapse> = (props) => {


    const items: CollapseProps['items'] = [
        {
          key: '1',
          label: 'Краткая аналитика',
          children: props.shortAnalytics,
        },
        {
          key: '2',
          label: 'Подбробная аналитика',
          children: <Progress 
                percent={props.numberBigAnalytics}
                format={(percent) => {return props.stringBigAnalytics}}
                type='circle'
            ></Progress>,
        },
      ];
    return <Collapse items={items}></Collapse>
}


export function Result() {
    const [images, setImages] = useState([]);
    const queried = React.useRef(false);
    const {id} = useParams<{id: string}>();
    const [messageApi, contextHolder] = message.useMessage();
    const [status, setStatus] = React.useState(-1);
    const [statusStr, setStatusStr] = React.useState('');
    const [namePapers, setNamePapers] = React.useState([]);
    const [bboxes, setBboxes] = React.useState([]);
    const [isError, setIsError] = React.useState(false);
    const [featuresLoaded, setFeatureLoaded] = React.useState(false);
    const [featuresElem, setFeaturesElem] = React.useState<React.ReactNode>(null);
    const [idealTitle, setIdealTitle] = React.useState('');
    const [file, setFile] = React.useState('');

    if (status == -1) {
        getStatus(localStorage.getItem('statusId') as string).then((e) => {
            setStatus(e.data.processed / e.data.total);
            setStatusStr(`${e.data.processed} / ${e.data.total}`)
        })
    }
    else if (status != 1) {
        setTimeout(() => {
            getStatus(localStorage.getItem('statusId') as string).then((e) => {
                setFeatureLoaded(e.data.features_loaded);
                if (e.data.features_loaded && featuresElem == null) {
                    getFile(id as string).then((ee) => {
                        var stat = (ee.data.text_locations.length / ee.data.images.length) * 100;
                        var error = (ee.data.text_locations.map((e: any) => e.diff_type.length))
                        var totalError = error.reduce((e: any, a: any) => e + a)
                        var stat_loader = <div>
                            <Typography.Text>
                                Название файла: <strong>{ee.data.name}</strong>
                            </Typography.Text>
                            <br />
                            <Typography.Text>
                                Название эталона: <strong>{ee.data.ideal_title}</strong>
                            </Typography.Text>
                            <br />
                            <div style={{
                                width: 200, height: 200, marginTop: 20,
                                display: 'flex',
                                gap: 20
                            }}>
                                <div className='progress-centered' style={{marginTop: 0}}>
                                    <Progress
                                        type='circle'
                                        percent={totalError / ee.data.images.length * 100}
                                        format={(percent) => `${totalError} / ${ee.data.images.length}`}
                                        status="exception"
                                    ></Progress>
                                    <Typography.Text style={{textAlign: 'center'}}>
                                    <strong style={{textAlign: 'center'}}>Ошибок в заголовках найдено</strong>
                                    </Typography.Text>
                                </div>
                                <div className='progress-centered' style={{marginTop: 0}}>
                                    <Progress
                                        type='circle'
                                        percent={stat}
                                        format={(percent) => `${ee.data.text_locations.length} / ${ee.data.images.length}`}
                                    ></Progress>
                                    <Typography.Text style={{textAlign: 'center'}}>
                                    <strong style={{textAlign: 'center'}}>Заголовков в страницах найдено</strong>
                                    </Typography.Text>
                                </div>
                            </div>
                        </div> 
                        setFeaturesElem(stat_loader)
                    })
                }
                if (e.data.error) {
                    messageApi.error(e.data.error_description);
                    setIsError(true);
                }
                setStatus(e.data.processed / e.data.total);
                setStatusStr(`${e.data.processed} / ${e.data.total}`)
            })
        }, 3000)
    }

    if (!queried.current && status == 1 && !isError) {
        queried.current = true;
        getFile(id as string).then((e) => {
            console.log(e.data.ideal_title);
            setIdealTitle(e.data.ideal_title);
            setFile('https://' + e.data.file.split('http://')[1]);
            setImages(e.data.images.map((img: any) => {
                return 'https://' + img.image.split('http://')[1]
            }));
            setNamePapers(e.data.text_locations.map((e: any) => {
                return e.page - 1
            }))
            setBboxes(e.data.text_locations.map((e: any) => {
                return {
                    page: e.page - 1,
                    bbox: e.coordinates,
                    errors: e.diff_type
                }
            }))
        });
    }



    return (
        status != 1 && !featuresLoaded ?
        <div className='progress-centered'>
            <Typography.Title level={2}>
                Файл обрабатывается
            </Typography.Title>
            <Progress 
                percent={status * 100}
                format={(percent) => {return statusStr}}
                type='circle'
            ></Progress>
            <Typography.Title level={4}>
                Страниц загружено
            </Typography.Title>
            
        </div> : 
        featuresLoaded && status != 1 ? 
        <div>
            <ResultCollapse
                shortAnalytics={featuresElem}
                numberBigAnalytics={status * 100}
                stringBigAnalytics={statusStr}
            ></ResultCollapse>
        </div> :
        <>
            {contextHolder}
            <div>

                <ImageViewer 
                    images={images} 
                    headIndexes={namePapers}
                    bboxes={bboxes}
                    idealTitle={idealTitle}
                    changeTitle={setIdealTitle}
                    file={file}
                ></ImageViewer>
            </div>
        </>
  );
}